import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** Polls the count of aging/past-due Medicaid applications routed to this
 *  therapist, for the "Medicaid Tracker" nav badge. Disabled for non-therapists. */
export function useMedicaidAlerts(enabled = true, intervalMs = 60000) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        if (!enabled) { setCount(0); return; }
        let active = true;
        const fetchCount = () => api.get("/provider/medicaid/alerts")
            .then((r) => { if (active) setCount((r.data || []).length); })
            .catch(() => {});
        fetchCount();
        const id = setInterval(fetchCount, intervalMs);
        return () => { active = false; clearInterval(id); };
    }, [enabled, intervalMs]);
    return count;
}
